import { render, staticRenderFns } from "./ProjectsCamerasTable.vue?vue&type=template&id=58097e06"
import script from "./ProjectsCamerasTable.vue?vue&type=script&lang=ts"
export * from "./ProjectsCamerasTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports